import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page8 = () => {
  return (
    <PageTypeA title={pagesDataA[4].title} subtitle={pagesDataA[4].subtitle} image={pagesDataA[4].image}/>
  );
};

export default Page8;
